import { ensureElement } from "../utils/utils";
import { Component } from "./base/Component";
import { CATEGORY_MODIFIERS } from "../utils/constants";
export class Product extends Component {
    constructor(container) {
        super(container);
        this._title = ensureElement('.card__title', this.container);
        this._price = ensureElement('.card__price', this.container);
    }
    set title(value) {
        this.setText(this._title, value);
    }
    set price(value) {
        this.setText(this._price, value !== null ? value + ' синапсов' : 'Бесценно');
    }
}
export class ProductPreview extends Product {
    constructor(container, actions) {
        super(container);
        this._category = ensureElement('.card__category', this.container);
        this._text = ensureElement('.card__text', this.container);
        this._image = ensureElement('.card__image', this.container);
        this._button = ensureElement('.card__button', this.container);
        if (actions.addToBasket) {
            this._button.addEventListener('click', actions.addToBasket);
        }
    }
    //Установка текста категории и css-класса, для изменения цвета плашки
    set category(value) {
        this.setText(this._category, value);
        Object.values(CATEGORY_MODIFIERS).forEach(modifier => {
            this._category.classList.remove(`card__category_${modifier}`);
        });
        // Добавляем нужный модификатор, если он есть в mapping
        const modifier = CATEGORY_MODIFIERS[value];
        if (modifier) {
            this._category.classList.add(`card__category_${modifier}`);
        }
    }
    set description(value) {
        this.setText(this._text, value);
    }
    set image(value) {
        this.setImage(this._image, value);
    }
    //Для изменения состояния кнопки, если товар уже в корзине или он не имеет цены
    setButtonState(inBasket, hasPrice) {
        this._button.disabled = inBasket || !hasPrice;
        if (!hasPrice) {
            this._button.textContent = 'Не для продажи';
        }
        else {
            this._button.textContent = inBasket ? 'В корзине' : 'В корзину';
        }
    }
}
export class ProductCatalogItem extends Product {
    constructor(container, actions) {
        super(container);
        if (actions.onClick) {
            this.container.addEventListener('click', actions.onClick);
        }
        this._category = ensureElement('.card__category', this.container);
        this._image = ensureElement('.card__image', this.container);
    }
    set category(value) {
        this.setText(this._category, value);
        Object.values(CATEGORY_MODIFIERS).forEach(modifier => {
            this._category.classList.remove(`card__category_${modifier}`);
        });
        // Добавляем нужный модификатор, если он есть в mapping
        const modifier = CATEGORY_MODIFIERS[value];
        if (modifier) {
            this._category.classList.add(`card__category_${modifier}`);
        }
    }
    set image(value) {
        this.setImage(this._image, value);
    }
}
export class ProductBasketItem extends Product {
    constructor(container, actions) {
        super(container);
        this._index = ensureElement('.basket__item-index', this.container);
        this._button = ensureElement('.card__button', this.container);
        if (actions.deleteFromBasket) {
            this._button.addEventListener('click', actions.deleteFromBasket);
        }
    }
    set index(value) {
        this.setText(this._index, value);
    }
    get index() {
        return Number(this._index.textContent);
    }
}
